/* Copyright 2021, Milkdown by Mirone. */
import { css } from '@emotion/css';
import { findParentNode } from '@milkdown/utils';
import { Decoration, DecorationSet } from 'prosemirror-view';
import { CursorStatus } from './status';
const createEmptyStyle = ({ font, palette }) => css `
    position: relative;
    &::before {
        position: absolute;
        cursor: text;
        font-family: ${font.typography};
        font-size: 0.875rem;
        color: ${palette('neutral', 0.6)};
        content: attr(data-text);
        height: 100%;
        display: flex;
        align-items: center;
    }
`;
const createSlashStyle = () => css `
    &::before {
        left: 0.5rem;
    }
`;
export const createProps = (status, utils, placeholder) => {
    const emptyStyle = utils.getStyle(createEmptyStyle);
    const slashStyle = utils.getStyle(createSlashStyle);
    return {
        handleKeyDown: (_, event) => {
            const { cursorStatus, activeActions } = status.get();
            if (cursorStatus !== CursorStatus.Slash || activeActions.length === 0) {
                return false;
            }
            if (!(event instanceof KeyboardEvent)) {
                return false;
            }
            if (!['ArrowUp', 'ArrowDown', 'Enter'].includes(event.key)) {
                return false;
            }
            return true;
        },
        decorations: (state) => {
            const parent = findParentNode(({ type }) => type.name === 'paragraph')(state.selection);
            const isTopLevel = state.selection.$from.depth === 1;
            if (!parent || parent.node.childCount > 1 || !isTopLevel) {
                status.clearStatus();
                return;
            }
            const isEmpty = parent.node.content.size === 0;
            const isSlash = parent.node.textContent === '/' && state.selection.$from.parentOffset > 0;
            const isSearch = parent.node.textContent.startsWith('/') && state.selection.$from.parentOffset > 1;
            const createDecoration = (text, className) => {
                const pos = parent.pos;
                return DecorationSet.create(state.doc, [
                    Decoration.node(pos, pos + parent.node.nodeSize, {
                        class: className.filter((x) => x).join(' '),
                        'data-text': text,
                    }),
                ]);
            };
            if (isEmpty) {
                status.clearStatus();
                const text = placeholder[CursorStatus.Empty];
                return createDecoration(text, [emptyStyle, 'empty-node']);
            }
            if (isSlash) {
                status.setSlash();
                const text = placeholder[CursorStatus.Slash];
                return createDecoration(text, [emptyStyle, slashStyle, 'empty-node', 'is-slash']);
            }
            if (isSearch) {
                status.setSlash(parent.node.textContent.slice(1));
                return null;
            }
            status.clearStatus();
            return null;
        },
    };
};
//# sourceMappingURL=props.js.map